<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li>
          <nuxt-link :to="localePath('office-users')">
            {{ $t("page.users") }}
          </nuxt-link>
        </li>

        <li class="is-active">
          <a aria-current="page">{{ $t("form.edit") }}</a>
        </li>
      </ul>
    </nav>
    <form @submit.prevent="onSubmit" style="width: 100%">
      <div class="columns">
        <div class="column">
          <field-input
            :value.sync="active.first_name"
            name="first_name"
            required
            :label="`${$t('form.first_name')}:`"
            :vvas="$t('form.first_name')"
          />
        </div>
        <div class="column">
          <field-input
            :value.sync="active.last_name"
            name="last_name"
            required
            :label="`${$t('form.last_name')}:`"
            :vvas="$t('form.last_name')"
          />
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <field-input
            :value.sync="active.company"
            name="company"
            required
            :label="`${$t('form.company')}:`"
            :vvas="$t('form.company')"
          />
        </div>
      </div>

      <hr />

      <div class="columns">
        <div class="column">
          <field-select
            :value.sync="active.glass_industry_id"
            name="glass_industry_id"
            required
            :label="`${$t('form.glass_industry')}:`"
            :vvas="$t('form.glass_industry')"
            :options="$store.getters['industries/glassIndustries']"
          />
        </div>
        <div class="column">
          <field-select
            :value.sync="active.metal_industry_id"
            name="metal_industry_id"
            required
            :label="`${$t('form.metal_industry')}:`"
            :vvas="$t('form.metal_industry')"
            :options="$store.getters['industries/metalIndustries']"
          />
        </div>
      
        <div class="column">
          <field-select
            :value.sync="active.hinge_industry_id"
            name="hinge_industry_id"
            :label="`${$t('form.hinge_industry')}:`"
            :vvas="$t('form.hinge_industry')"
            :options="$store.getters['industries/hingeIndustries']"
          />
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <field-select
            :value.sync="active.wood_industry_id"
            name="wood_industry_id"
            :label="`${$t('form.wood_industry')}:`"
            :vvas="$t('form.wood_industry')"
            :options="$store.getters['industries/woodIndustries']"
          />
        </div>
        <div class="column">
          <field-select
            :value.sync="active.stone_industry_id"
            name="stone_industry_id"
            :label="`${$t('form.stone_industry')}:`"
            :vvas="$t('form.stone_industry')"
            :options="$store.getters['industries/stoneIndustries']"
          />
        </div>
      </div>

      <hr />

      <div class="columns">
        <div class="column">
          <field-select
            :value.sync="active.country_id"
            name="country_id"
            required
            :label="`${$t('form.country')}:`"
            :vvas="$t('form.country')"
            :options="countries"
          />
        </div>
        <div class="column">
          <field-select
            :value.sync="active.state_id"
            name="state_id"
            required
            :title="!active.country_id && $t('message.please_select_country')"
            :disabled="!active.country_id"
            :options="stateOptions"
            :label="`${$t('form.state')}:`"
            :vvas="$t('form.state')"
          />
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <field-input
            :value.sync="active.city"
            name="city"
            required
            :label="`${$t('form.city')}:`"
            :vvas="$t('form.city')"
          />
        </div>
        <div class="column">
          <field-input
            :value.sync="active.street_name"
            name="street_name"
            required
            :label="`${$t('form.street_name')}:`"
            :vvas="$t('form.street_name')"
          />
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <field-input
            :value.sync="active.street_number"
            name="street_number"
            required
            :label="`${$t('form.street_number')}:`"
            :vvas="$t('form.street_number')"
          />
        </div>
        <div class="column">
          <field-input
            :value.sync="active.zipcode"
            name="zipcode"
            required
            :label="`${$t('form.zipcode')}:`"
            :vvas="$t('form.zipcode')"
          />
        </div>
      </div>

      <hr />

      <div class="columns">
        <div class="column">
          <field-input
            :value.sync="active.email"
            name="email"
            type="email"
            required
            :label="`${$t('form.email')}:`"
            :vvas="$t('form.email')"
          />
        </div>
        <div class="column">
          <field-input
            :value.sync="active.phone_number"
            name="phone_number"
            required
            :prefix="active.country_id && dialCode"
            :title="!active.country_id && $t('message.please_select_country')"
            :disabled="!active.country_id"
            :label="`${$t('form.phone_number')}:`"
            :vvas="$t('form.phone_number')"
          />
        </div>
      </div>

      <hr />

      <div class="columns">
        <div class="column">
          <field-select
            :value.sync="active.product_class"
            name="product_class"
            required
            :label="`${$t('form.product_class')}:`"
            :vvas="$t('form.product_class')"
            :options="[
              { id: 1, name: '1 - ' + $t('form.few_products') },
              2,
              3,
              4,
              { id: 5, name: '5 - ' + $t('form.all_products') },
            ]"
          />
        </div>
        <div class="column">
          <field-select
            :value.sync="active.category"
            name="category"
            required
            :label="`${$t('form.category')}:`"
            :vvas="$t('form.category')"
            :options="['A', 'B', 'C', 'D']"
          />
        </div>
      </div>

      <hr />

      <div class="columns">
        <div class="column">
          <field-select
            :value.sync="active.industry_branch_id"
            name="category"
            required
            :label="`${$t('form.branch')}:`"
            :vvas="$t('form.branch')"
            :options="industry_branches"
          />
        </div>
        <div class="column">
          <field-input
            :value.sync="active.tax_id"
            name="tax_id"
            required
            :label="`${$t('form.tax_id')}:`"
            :vvas="$t('form.tax_id')"
          />
        </div>
      </div>

      <hr />

      <div class="columns">
        <div class="column">
          <field-input
            :value.sync="active.commission_fee"
            name="glass_commission_fee"
            required
            :label="`${$t('form.glass_commission_fee')}:`"
            :vvas="$t('form.glass_commission_fee')"
            type="number"
            unit="%"
          />
        </div>
        <div class="column">
          <field-input
            :value.sync="active.metal_commission_fee"
            name="metal_commission_fee"
            required
            :label="`${$t('form.metal_commission_fee')}:`"
            :vvas="$t('form.metal_commission_fee')"
            type="number"
            unit="%"
          />
        </div>
        <div class="column">
          <field-input
            :value.sync="active.hinge_commission_fee"
            name="hinge_commission_fee"
            required
            :label="`${$t('form.hinge_commission_fee')}:`"
            :vvas="$t('form.hinge_commission_fee')"
            type="number"
            unit="%"
          />
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <field-input
            :value.sync="active.wood_commission_fee"
            name="wood_commission_fee"
            required
            :label="`${$t('form.wood_commission_fee')}:`"
            :vvas="$t('form.wood_commission_fee')"
            type="number"
            unit="%"
          />
        </div>
        <div class="column">
          <field-input
            :value.sync="active.stone_commission_fee"
            name="stone_commission_fee"
            required
            :label="`${$t('form.stone_commission_fee')}:`"
            :vvas="$t('form.stone_commission_fee')"
            type="number"
            unit="%"
          />
        </div>
      </div>

      <hr />

      <div class="columns">
        <div class="column">
          <field-checkbox
            :value.sync="active.active"
            name="active"
            :label="`${$t('form.active')}?`"
            :vvas="$t('form.active')"
          />
        </div>
        <div class="column">
          <field-checkbox
            :value.sync="active.special_user"
            name="special_user"
            :label="`${$t('form.special_user')}?`"
            :vvas="$t('form.special_user')"
          />
        </div>
      </div>

      <div class="field m-t-5">
        <div class="control is-clearfix">
          <button
            class="button is-primary is-pulled-right"
            :class="{ 'is-loading': formLoading }"
          >
            {{ $t("form.submit") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  async asyncData({ store, params, error }) {
    try {
      await store.dispatch("users/setActiveUser", params.id);
    } catch (e) {
      error(e);
    }
  },

  data() {
    return {
      formLoading: false,
    };
  },

  watch: {
    country_id() {
      this.state_id = null;
    },
  },

  computed: {
    active() {
      return this.$store.state.users.active;
    },

    countries() {
      return this.$store.getters["options/countries"];
    },

    industry_branches() {
      return this.$store.state.options.industry_branches;
    },

    dialCode() {
      if (
        this.active.country_id === null ||
        this.active.country_id === undefined
      )
        return;

      return this.choosenCountry && this.choosenCountry.dial_code;
    },

    choosenCountry() {
      return this.countries.find((e) => e.id === this.active.country_id);
    },

    stateOptions() {
      if (
        this.active.country_id === null ||
        this.active.country_id === undefined
      )
        return;

      return this.choosenCountry && this.choosenCountry.states;
    },

    typeOptions() {
      return [
        {
          id: "glass",
          name: this.$t("form.glass"),
        },
        {
          id: "metal",
          name: this.$t("form.metal"),
        },
        {
          id: "hinge",
          name: this.$t("form.hinge"),
        },
        {
          id: "wood",
          name: this.$t("form.wood"),
        },
        {
          id: "stone",
          name: this.$t("form.stone"),
        },
      ];
    },
  },

  methods: {
    async onSubmit() {
      const validation = await this.$validator.validateAll();
      if (!validation) return;

      this.formLoading = true;

      try {
        const { data } = await this.$api.updateUser(
          this.$route.params.id,
          this.active
        );

        this.$store.commit("users/UPDATE_ITEM", data);

        this.$router.push(
          this.localePath({ name: "office-users-id", params: { id: data.id } })
        );
      } catch (e) {
        console.log(e);
        this.handleFormError(e.response.data);
      }

      this.formLoading = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/nuxt/pages/office/users/edit/_id.vue